
const styles = {
    display: "flex",
    justifyContent: "end",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: "transparent"
};
const inputStyles = {
    padding: "clamp(12px, 2vw, 16px)",
    paddingLeft: "clamp(14px, 2.5vw, 19px)",
    borderRadius: "5px",
    width: "100%",
    color: " #7f7f7f",
    fontWeight: "600",
    fontFamily: "var(--font-paragraph)"
};
const labelStyles = {
    color: "white",
    fontWeight: "700",
    fontFamily: "var(--font-label",
    fontSize: "var(--font-label-size)"
};

export { styles, inputStyles, labelStyles };